export default __webpack_public_path__ + "static/media/water5.2b2d9bbd.png";